// src/App.js
import React, { useEffect } from 'react';
import Menu from './components/Menu';
import Content from './components/Content';
import { BrowserRouter as Router } from 'react-router-dom';
import { SettingsProvider } from './SettingsContext';
import './App.css';
import { ToastContainer } from 'react-toastify'; // Импортируйте ToastContainer
import 'react-toastify/dist/ReactToastify.css'; // Импортируйте стили
import { AliveScope } from 'react-activation';

function App() {
  // Эффект для настройки Telegram WebApp и скрытия свайпов
  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      window.Telegram.WebApp.isOrientationLocked = true;
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.disableVerticalSwipes();
      window.Telegram.WebApp.disableClosingConfirmation();
    }

  }, []);

  return (
    <AliveScope>
      <SettingsProvider>
        <Router>
          <>
            <Content />
            <Menu />
          </>
        </Router>
      </SettingsProvider>
      <ToastContainer />
    </AliveScope>
  );
}

export default App;
